/* eslint-disable*/
import React from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { Icon } from 'antd';
import 'react-photo-view/dist/react-photo-view.css';
import './index.less'

const PhotoPreview = ({ img, ...others }) => {

  return (
    <PhotoProvider
      className='photo-preview-dialog'
      toolbarRender={({ rotate, onRotate, onScale, scale }) => {
        return (
          <>
            <Icon type="undo" className='photo-icon' onClick={() => onRotate(rotate - 90)} />
            <Icon type="redo" className='photo-icon' onClick={() => onRotate(rotate + 90)} />
            <Icon type="plus-circle" className='photo-icon' onClick={() => onScale(scale + 1)} />
            <Icon type="minus-circle" className='photo-icon' onClick={() => onScale(scale - 1)} />
          </>
        );
      }}>
      <div className="foo">
        <PhotoView key={'face_auth_img_' + 1 + '_' + img} src={img}>
          <img {...others} src={img} />
        </PhotoView>
      </div>
    </PhotoProvider>
  )
}
export default PhotoPreview
